const STORAGE_NAME = 'parent_order_id'
export const setOrderId = orderId => {
  localStorage.setItem(STORAGE_NAME, orderId)
}

export const gerOrderId = () => {
  let x = localStorage.getItem(STORAGE_NAME)
  removeOrderId()
  return x
}

export const removeOrderId = () => {
  localStorage.removeItem(STORAGE_NAME)
}
